import { render, staticRenderFns } from "./sizhen-caiji.vue?vue&type=template&id=baafa7f2&scoped=true&"
import script from "./sizhen-caiji.vue?vue&type=script&lang=ts&"
export * from "./sizhen-caiji.vue?vue&type=script&lang=ts&"
import style0 from "./sizhen-caiji.vue?vue&type=style&index=0&id=baafa7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baafa7f2",
  null
  
)

export default component.exports